import UrlBreakoutDashboard from './UrlBreakoutDashboard';

export default UrlBreakoutDashboard;
